import { envIS_TEST } from 'src/env/envIS_TEST';

export function isJestTest(): boolean {
    return envIS_TEST();
}
